// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"G5-z","dimensionLabel":"H5-z","styleChooserControlWrapper":"I5-z","styleChooserControl":"J5-z","disabled":"K5-z","giftCard":"L5-z","styleChooserText":"M5-z"};